var generic = generic || {};
var google = google || {};
var omnidata = omnidata || {};
var tms_page_data = tms_page_data || {};
tms_page_data.tms_page_info = tms_page_data.tms_page_info || {};
var InfoBox = InfoBox || {};

(function($, Drupal, site) {
  'use strict';
  site.locator = site.locator || {};
  site.locator.ui = site.locator.ui || {};
  site.locator.data = site.locator.data || {};

  site.locator.map = null; // Google map object
  site.locator.mapDir = null; // Google map object
  site.locator.markers = []; // Array of google.maps.marker objects, ordered the same way as their corresponding doors in site.locator.resultData.results
  site.locator.locationsHtml = []; // Array of HTML snippets for info windows, ordered the same way as their corresponding doors in site.locator.resultData.results
  site.locator.resultData = {}; // contains results from doors query.
  site.locator.resultData.results = []; // contains ordered results from doors query.
  site.locator.infoWindow = null; // google.maps.InfoWindow object
  site.locator.infoWindowDir = null; // google.maps.InfoWindow object
  site.locator.queryFields = 'DOOR_ID, DOORNAME, EVENT_NAME, SUB_HEADING, EVENT_START_DATE, EVENT_END_DATE, EVENT_IMAGE, EVENT_FEATURES, EVENT_TIMES, SERVICES, STORE_HOURS, ADDRESS, ADDRESS2, STATE_OR_PROVINCE, CITY, REGION, COUNTRY, ZIP_OR_POSTAL, PHONE1, PHONE2, STORE_TYPE, LONGITUDE, LATITUDE, COMMENTS';
  site.locator.markerCounter = 0;
  site.locator.travelMode = 'DRIVING';

  site.locator.defaultCountries = '';
  site.locator.queryArgs = '';
  site.locator.intSearchType = false;
  site.locator.favoriteStoreID = null;
  site.locator.locationData = site.locator.locationData || {};
  site.locator.distanceUnit = Drupal.settings.globals_variables.default_distance_unit || 'km';

  //site.locator.ui.getRBs = function() {
  //  var rb = generic.rb("language");
  //  site.locator.rb = {
  //      view_details :   rb.get("view_details"),
  //      store :          rb.get("store"),
  //      address :        rb.get("address"),
  //      phone :          rb.get("phone"),
  //      event_js :       rb.get("event_js"),
  //      search_results : rb.get("search_results"),
  //      no_criteria :    rb.get("no_criteria"),
  //      search_error :   rb.get("search_error")
  //  };
  //};

  site.locator.getDomNodes = function() {
    var $wrapper = $('.store-locator');

    site.locator.nodes = {
      wrapper: $wrapper,
      moreResultsContainer: $('.more-results-container', $wrapper),
      moreResultsButton: $('.more-results.button', $wrapper),
      countryMenu: $('select.country', $wrapper),
      localcountryMenu: $('select.local_country', $wrapper),
      localCountries: $('#local_countries', $wrapper),
      cityMenuIntl: $('select.city_intl', $wrapper),
      stateMenu: $('select.state', $wrapper),
      cityMenu: $('select.js-city', $wrapper),
      doorMenu: $('select.door', $wrapper),
      doorRows: $('.door_row', $wrapper),
      doorWithEventRows: $('.door_row', $wrapper),
      doorWithoutEventRows: $('.door_row', $wrapper),
      searchInput: $('input.search', $wrapper),
      select_text: $('#locator-select', $wrapper),
      distanceMenu: $('select.distance', $wrapper),
      searchForm: $('form.form--search', $wrapper),
      searchFormIntl: $('form.form--search--intl', $wrapper),
      searchBtn: $('.store-locator__submit', $wrapper),
      searchAltTxt: $('.search_alternative_text', $wrapper),
      searchBtnGeo: $('.geo_search', $wrapper),
      searchBtnIntl: $('#search_button_intl', $wrapper),
      searchPanel: $('fieldset#store-search-controls', $wrapper),
      landingPanel: $('div.locator_landing', $wrapper),
      mapPanel: $('div.locations_map_panel', $wrapper),
      map: $('div#map', $wrapper),
      services: $('#services', $wrapper),
      servicesClose: $('#cboxClose', $wrapper),
      results_panel: $('div.results_panel', $wrapper),
      storeResults: $('div#store_results', $wrapper),
      landing_only_panel: $('.js-store_landing_only'), // lives outside of $wrapper
      // eventResults     : $('div#event_results', $wrapper),
      locatorErrors: $('ul.locator_error_messages', $wrapper),
      locatorErrors_intl: $('ul.locator_error_messages_intl', $wrapper),
      dirStateMenuContainer: $('div.dir_state_container', $wrapper),
      dirCountryMenu: $('select.dirCountry', $wrapper),
      dirDestination: $('div.destination', $wrapper),
      invalidZip: $('#locator-invalid-zip', $wrapper),
      missingCityUS: $('#locator-missing-city-us', $wrapper),
      missingCityIntl: $('#locator-missing-city-intl', $wrapper),
      dirInvalidAddress: $('#locator-dir-invalid-address', $wrapper),
      dirNoRoute: $('#locator-dir-no-route', $wrapper),
      dirUnknownError: $('#locator-dir-unknown-error', $wrapper),
      localRegionIds: $('#region_ids', $wrapper),
      localLanguageIds: $('#language_ids', $wrapper),
      intllocalRegionIds: $('#intl_region_ids', $wrapper),
      stateContainer: $('.state_container', $wrapper),
      localCountryContainer: $('.local_country_container', $wrapper),
      filterMenu: $('select.filters', $wrapper),
      filtersOptions: $('select.filters option', $wrapper).clone(),
      countryContainer: $('select.country_container', $wrapper),
      localCountry: $('#country_container', $wrapper),

      // Store Locator landing page form
      jsDropdownToggle: $('.js-dropdown-toggle', $wrapper),
      formSearchAdvanced: $('.form--search--advanced', $wrapper),
      allSelects: $('select', $wrapper),
      allRadios: $('input[type=radio], input[type=checkbox]', $wrapper),

      errors: {
        noSearchTerm: $('ul.error_messages li.no-search-term', $wrapper),
        noLocationsFound: $('ul.error_messages li.no-locations-found', $wrapper),
        noStoresFound: $('ul.error_messages li.no-stores-found', $wrapper),
        unrecognizedSearchTerm: $('ul.error_messages li.unknown-error', $wrapper)
      }
    };

    // Remove the geolocation buttons when it's not available to the browser
    if (!navigator.geolocation || (generic.env.isFF && parseInt($.browser.version) <= 27)) {
      site.locator.nodes.searchBtnGeo.parent('.form_element').detach();
      site.locator.nodes.searchAltTxt.detach();
    }
  };

  site.locator.ui.getTemplates = function() {
    var temp = {};
    generic.template.get({path: '/templates/locator/location_info.tmpl', callback: function() {}, object: temp});
    generic.template.get({path: '/templates/locator/doors_table.tmpl', callback: function() {}, object: temp});
    generic.template.get({path: '/templates/locator/door_row.tmpl', callback: function() {}, object: temp});
  };

  /**
   * This function initializes the UI elements of the Store Locator page.
   * It communicates with site.locator.data via events.
   */
  site.locator.ui.init = function() {
    if (typeof site.locator.locationData === 'undefined') {
      return; // no location data!
    }
    if ($.isEmptyObject(site.locator.locationData)) {
      $.getScript('/locator/store_data.tmpl')
        .done(function() {
          if (!site.locator.ui.inited) {
            site.locator.ui.inited = true;
            site.locator.ui.init();
          }
        });
      return;
    }

    // picker library
    site.locator.nodes.allRadios.picker();

    _hideErrorMsg();

    site.locator.defaultCountries = $('#local_countries').val();
    var countryArr = site.locator.defaultCountries.split(',');
    var options = site.locator.nodes.localCountry;
    $.each(countryArr, function(index, value) {
      options.append(new Option(value));
      site.locator.nodes.localCountry.select2('val', null);
    });

    /*
       * This function takes a select menu, removes its options, then adds an option with name="Default" and value = ""
       */
    var _clearMenu = function(menu) {
      //menu[0].options.length = 0;
      menu.select2('val', '');
      // wipe out menu html
      menu.html('');

      // rebuild
      generic.forms.select.addOption({
        menuNode: menu,
        label: menu.attr('title') ? menu.attr('title') : site.locator.nodes.select_text.text(),
        value: ''
      });
    };

    /*
       * Initializes select menus by adding default option and populating the State menu from JSON data in page
       */
    var _initMenus = function() {
      // insert default options

      $([ site.locator.nodes.countryMenu,
        site.locator.nodes.localcountryMenu,
        site.locator.nodes.cityMenuIntl,
        site.locator.nodes.stateMenu,
        site.locator.nodes.cityMenu,
        site.locator.nodes.doorMenu]).each(function() {
        _clearMenu($(this));
      });

      // populate local country select first if visible
      for (var country in site.locator.locationData) {
        if (country !== '') {
          if (site.locator.defaultCountries.indexOf(country) !== -1) {
            if (site.locator.nodes.stateContainer.hasClass('neither') || site.locator.nodes.cityMenu.length >= 1) { // only showing city filter...
              for (var state in site.locator.locationData[country]) {
                if (state !== '' || Drupal.settings.elc_common.elc_site_type.coresite) {
                  for (var city in site.locator.locationData[country][state]) {
                    if (city !== '') {
                      generic.forms.select.addOption({
                        menuNode: site.locator.nodes.cityMenu,
                        value: city
                      });
                    }
                  }
                }
              }
            } else if (!site.locator.nodes.localCountryContainer.hasClass('state')) {// showing local country filter...
              generic.forms.select.addOption({
                menuNode: site.locator.nodes.localcountryMenu,
                value: country
              });
            } else { // showing state
              for (var state_only in site.locator.locationData[country]) {
                if (state_only !== '') {
                  generic.forms.select.addOption({
                    menuNode: site.locator.nodes.stateMenu,
                    value: state_only
                  });
                }
              }
            }
          } else {
            generic.forms.select.addOption({
              menuNode: site.locator.nodes.countryMenu,
              value: country
            });
            generic.forms.select.addOption({
              menuNode: site.locator.nodes.dirCountryMenu,
              value: country
            });
          }
        }
      }
      site.locator.nodes.countryMenu.val(site.locator.nodes.countryMenu.data('country-selected'));
    };

    var _localcountryMenuChangeHandler = function(stateNode, cityNode) {
      _clearMenu(stateNode);
      _clearMenu(cityNode);

      // populate state drop-down if visible, otherwise populate city drop-down
      if (!site.locator.nodes.stateContainer.hasClass('country')) {
        for (var state_only in site.locator.locationData[site.locator.nodes.localcountryMenu.val()]) {
          if (state_only === '') {
            generic.forms.select.addOption({
              menuNode: stateNode,
              value: state_only
            });
          }
        }
        stateNode.focus();
      } else {
        var cities = {};
        for (var state in site.locator.locationData[site.locator.nodes.localcountryMenu.val()]) {
          if (state !== '') {
            jQuery.extend(cities, site.locator.locationData[site.locator.nodes.localcountryMenu.val()][state]);
          }
        }
        _filterCityMenu(cityNode, cities);
        _sortSelect(cityNode);
        cityNode.focus();
      }
    };

    var _countryMenuChangeHandler = function(cityNode) {
      var cities = {};
      for (var state in site.locator.locationData[site.locator.nodes.countryMenu.val()]) {
        if (state !== '') {
          jQuery.extend(cities, site.locator.locationData[site.locator.nodes.countryMenu.val()][state]);
        }
      }
      _filterCityMenu(cityNode, cities);
      _sortSelect(cityNode);
      cityNode.focus();
    };

    /*
       * Event handler for onchange event on State menu
       */
    var _stateMenuChangeHandler = function(cityNode, locationData) {
      _filterCityMenu(cityNode, locationData[site.locator.nodes.stateMenu.val()]);
      cityNode.focus();
    };

    /*
       * Reads value from state menu and populates city menu with the appropriate values, based on JSON data in page
       */
    var _filterCityMenu = function(cityNode, locationData) {
      _clearMenu(cityNode);
      // retrieve cities from that state, populate city menu
      var cityData = locationData;

      for (var city in cityData) {
        if (city !== '') {
          generic.forms.select.addOption({
            menuNode: cityNode,
            value: city
          });
        }
      }
      _clearMenu(site.locator.nodes.doorMenu);
    };

    /*
       * Sort select options in alphabetical order
       */
    var _sortSelect = function(selectNode) {
      var listItems = selectNode.children('option').get();
      listItems.sort(function(a, b) {
        return $(a).val().toUpperCase().localeCompare($(b).val().toUpperCase());
      });
      $.each(listItems, function(idx, itm) {
        selectNode.append(itm);
      });
    };

    /*
       * Event handler for onchange event on City menu
       */
    var _cityMenuChangeHandler = function(doorNode, locationData) {
      var state = site.locator.nodes.stateMenu.val();
      var city = site.locator.nodes.cityMenu.val();
      //_filterDoorMenu(doorNode, locationData[state][city]);
      doorNode.focus();
    };

    /*
       * Reads value from city menu and populates door (store) menu with the appropriate values, based on JSON data in page
       */
    var _filterDoorMenu = function(doorNode, locationData) {
      _clearMenu(doorNode);
      var storeArray = locationData;
      for (var i = 0; i < storeArray.length; i++) {
        generic.forms.select.addOption({
          menuNode: doorNode,
          value: storeArray[i]
        });
      }
    };

    /*
       * Event handler for click of Doors search button
       */
    var _searchClickHandler = function() {
      var googleCountryNameSubstitution = {};
      _hideErrorMsg();
      var country = site.locator.nodes.countryMenu.val();
      var country_all = site.locator.nodes.countryContainer.val();
      var search = '';
      var global_var = Drupal.settings && Drupal.settings.globals_variables ? Drupal.settings.globals_variables : '';
      var splCharRegex = global_var && global_var.spl_char_regex ? new RegExp(global_var.spl_char_regex, 'ug') : /[!@#$%&()*+,-.:;<=>?@[\]^_`{|}~"'\\//]/ug;
      var distance = site.locator.nodes.distanceMenu.val();
      if (site.locator.intSearchType) {
        country = site.locator.nodes.countryMenu.val();
        search = site.locator.nodes.cityMenuIntl.val();
      } else {
        // Grab from the 'local_countries' setting.
        country = site.locator.nodes.countryContainer.val(); //'United States';
        var cityVal = site.locator.nodes.cityMenu.length >= 1 ? site.locator.nodes.cityMenu.val() : '';
        var searchTextVal = '';
        if (site.locator.nodes.searchInput.length >= 1) {
          searchTextVal = jQuery.trim(site.locator.nodes.searchInput.val().replace(site.locator.nodes.searchInput.attr('placeholder'), ''));
        }
        search = searchTextVal ? searchTextVal : cityVal;
      }
      site.locator.nodes.filterMenu.val('all');
      // Setting the default country to US for one isn't selected.
      var isUS = site.locator.nodes.countryMenu.val().match(/^united states*/i) ? true : !!(!site.locator.nodes.countryMenu.val() || !site.locator.nodes.countryMenu.val().length);

      // Restrict address requirement to US searches only.
      //  If the user has attempted a "manual" search with no location/term, throw an error.
      if (isUS) {
        if (!search) {
          _showErrorMsg(site.locator.nodes.errors.noSearchTerm);
          return;
        }
        if (!isNaN(distance) && distance < 30) {
          distance = 50; // Must ensure a minimum radius of 50. This is temporary.
        }
      }

      search = search.replaceAll(splCharRegex, ' ');

      // get current content from main search text field, and run it through the geocoder
      var geocoder = new google.maps.Geocoder();
      var passPostcode = site.locator.nodes.wrapper.data('pass-postcode');
      search = !isNaN(search) && passPostcode ? 'postcode ' + search : search;

      // @todo longer term fix will be to but this object into a centeralized location so all brands can access.
      googleCountryNameSubstitution = {
        'Hong Kong, SAR of China': 'HK',
        'Hong Kong, RAS de Chine': 'HK',
        'Macau, SAR of China': 'MO',
        'China Mainland': 'CN',
        'Chine Continentale': 'CN',
        'Taïwan, Chine': 'TW',
        'KSA': 'SA'
      };

      if (generic.cookie('XBORDERPT') === 1 && Drupal.settings.globals_variables.XBorder_country) {
        country = Drupal.settings.globals_variables.XBorder_country;
      } else {
        country = googleCountryNameSubstitution[country] ? googleCountryNameSubstitution[country] : country;
      }

      if (!country) {
        country = site.locator.nodes.localCountries.val();
      }
      
      geocoder.geocode({
        'address': search,
        'componentRestrictions': {
          'country': country
        }
      }, function(results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          var filteredResults = {};
          if (search) {
            filteredResults = site.locator.geocodeResultFilter(results);
          }

          // Handle country searches.
          if (!isUS) {
            if (!search) {
              filteredResults = results;
              country_all = country;
            }
          }

          if (filteredResults && filteredResults.length > 0) {
            _searchBaseHandler(results[0].geometry.location.lat(), results[0].geometry.location.lng(), distance, country_all);
            site.locator.addressDisplayData = results[0].formatted_address;
            site.locator.foundLocationData = results;
            site.locator.remainingLocationData = results.slice(1);
          } else {
            _showErrorMsg(site.locator.nodes.errors.noLocationsFound);
          }
        } else {
          _showErrorMsg(site.locator.nodes.errors.unrecognizedSearchTerm);
        }
      });

      site.locator.nodes.searchInput.blur();
    };

    var _searchGeoClickHandler = function() {
      _searchBaseHandler('', '', '', '', true);
    };

    /*
       * Collects parameters from form input elements, packs them into parameters,
       * then passes them to search query via the "locator:submitSearchQuery" event.
       * @see site.locator.data.submitQuery
       * @param use_header {bool} Ignores lat and lng passed as params from GEOCODER and takes coordinates from AKAMAI
       */
    var _searchBaseHandler = function(lat, lng, distance, country, use_header) {
      use_header = use_header || false;
      var queryArgs = {
        params: [{
          'fields': site.locator.queryFields,
          'country': country,
          'latitude': lat,
          'longitude': lng,
          'uom': site.locator.distanceUnit
        }]
      };
      var currentCityVal = site.locator.nodes.cityMenu.length ? site.locator.nodes.cityMenu.val() : '';
      var passCityRpc = site.locator.nodes.wrapper.data('pass-city');
      if (!!use_header) {
        queryArgs.params[0]['use_header'] = 1;
      }
      if (site.locator.intSearchType) {
        queryArgs.params[0].region_id = 0;
        queryArgs.params[0].radius = 100;
      } else {
        queryArgs.params[0].radius = distance || site.locator.nodes.distanceMenu.val();
        var regionId = site.locator.nodes.localRegionIds.val();
        var languageId = site.locator.nodes.localLanguageIds.val();
        if (!!regionId) {
          queryArgs.params[0].region_id = regionId;
        }
        if (!!languageId) {
          queryArgs.params[0].language_id = languageId;
        }
        if (!!currentCityVal && !!passCityRpc) {
          queryArgs.params[0].city = currentCityVal;
        }
      }

      queryArgs.callback = function() {
        site.locator.ui.displayResultsTable();
        site.locator.ui.displayMap();
      };

      $(document).trigger('locator.submitSearchQuery', [queryArgs]);

      site.locator.queryArgs = queryArgs;
    };

    _initMenus();

    // prepopulate search field with form-submitted search value, if we're passed one, then submit
    var presubmittedSearch = generic.env.query('search');
    if (presubmittedSearch) {
      site.locator.nodes.searchInput.val(decodeURIComponent(presubmittedSearch).replace('+', ' '));
    }

    site.locator.nodes.countryMenu.bind('change', function() {
      _countryMenuChangeHandler(site.locator.nodes.cityMenuIntl);
      _disableSearchBtn();
    });

    site.locator.nodes.cityMenuIntl.bind('change', function() {
      _disableSearchBtn();
    });

    site.locator.nodes.searchBtnGeo.bind('click', function(e) {
      _searchGeoClickHandler();
    });

    site.locator.nodes.searchForm.submit(function() {
      site.locator.intSearchType = false;
      site.locator.nodes.countryMenu.val(null).trigger('change');
      site.locator.nodes.formSearchAdvanced.removeClass('has-js-dropdown-open').find('.options').hide(300);
      _searchClickHandler();
      return false;
    });

    site.locator.nodes.searchFormIntl.submit(function() {
      site.locator.intSearchType = true;
      // reset search input field
      site.locator.nodes.searchInput.val('');
      site.locator.nodes.cityMenu.val('');
      site.locator.nodes.formSearchAdvanced.removeClass('has-js-dropdown-open').find('.options').show(300);
      _searchClickHandler();
      return false;
    });

    site.locator.nodes.searchInput.bind('change', function(e) {
      site.locator.nodes.countryMenu.selectedIndex = 0;
    });

    site.locator.ui.displayMap();

    site.locator.nodes.results_panel.hide();

    // if we'd previously found a search term coming to us through the query string, and
    // have put it in our search field... trigger the click event, so that it's submitted
    if (presubmittedSearch) {
      site.locator.nodes.searchBtn.click();
    }

    site.locator.chooseRandomBGImage();
    site.locator.nodes.servicesClose.bind('click', function(e) {
      e.preventDefault();
      site.locator.showHideServices(false);
    });

    $(window).on('local_store_data', function(e) {
      site.locator.renderLocalStores();
      // site.locator.renderLocalEvents();
    });
  };
  /*
  site.locator.renderLocalStores = function(results) {
    if (results.length > 1) {
      $('.stores-near-you').removeClass('hidden');
      for (var i = 0; i < 2; i++) {
        results[i].DISTANCE = Math.round(results[i].DISTANCE * 100) / 100;
        generic.template.get({
          path:'/templates/locator/door_local.tmpl',
          object  : results[i],
          callback: function(html) {
            $('.js-store_'+i).html(html);
          }
        });
      }
    }
  };

  site.locator.renderLocalEvents = function(results) {
    var events = $(results).filter(function(i, event){
      if ( event.EVENT_START_DATE !== null && event.EVENT_END_DATE !== null && event.EVENT_NAME !== '') {
        return (new Date(event.EVENT_END_DATE.replace(/-/g, ' ') > new Date()));
      }
      return false;
    });
    if (events.length > 0) {
      $(events).each(function(i, event){
        event.index = i + 1;
        var event_start = new Date(event.EVENT_START_DATE.replace(/-/g, ' '));
        var dayNames = $('[data-local_days_of_week]').attr('data-local_days_of_week').replace(/"/g, '').split(',');
        event.EVENT_START_DATE = dayNames[event_start.getDay()] + ' ' + event.EVENT_START_DATE.replace(/00:00:00/g, '');
        event.EVENT_END_DATE = event.EVENT_END_DATE.replace(/00:00:00/g, '');
        generic.template.get({
          path:'/templates/locator/door_event.tmpl',
          object  : event,
          callback: function(html) {
            // append only if we have a match on the event name
            $('.events-near-you .custom-grid').append($('[data-store_event="'+event.EVENT_NAME+'"]', $(html)).first());
          }
        });
      });
      if ($('.events-near-you .custom-grid').html() !== '') {
        $('.events-near-you').removeClass('hidden');
      }
    }
  };
  */
  site.locator.renderLocalStores = function() {
    /*jshint -W083 */
    for (var i = 0; i < sessionStorage.LOCAL_STORE_COUNT; i++) {
      $('.stores-near-you').removeClass('hidden');
      var store = {};
      store.DOORNAME = sessionStorage['DOORNAME_' + i];
      store.LATITUDE = sessionStorage['LATITUDE_' + i];
      store.LONGITUDE = sessionStorage['LONGITUDE_' + i];
      store.SUB_HEADING = sessionStorage['SUB_HEADING_' + i];
      store.DISTANCE = Math.round(sessionStorage['DISTANCE_' + i] * 100) / 100;
      store.DOOR_ID = parseInt(sessionStorage['DOOR_ID_' + i]);
      store.ADDRESS = sessionStorage['ADDRESS_' + i];
      store.CITY = sessionStorage['CITY_' + i];
      store.STATE_OR_PROVINCE = sessionStorage['STATE_OR_PROVINCE_' + i];
      store.ZIP_OR_POSTAL = sessionStorage['ZIP_OR_POSTAL_' + i];
      store.PHONE1 = sessionStorage['PHONE_' + i];
      store.PHONE2 = sessionStorage['PHONE2_' + i];
      var thisStore = $('.js-store_' + i);
      generic.template.get({
        path: '/templates/locator/door_local.tmpl',
        object: store,
        callback: function(html) {
          thisStore.html(html);
        }
      });

      site.locator.favoriteStore(thisStore, store);
    }
  };

  /*
   * This function fetches the JS template: /templates/locator/location_info.tmpl
   * and uses it to create the info windows that are displayed when clicking on a pointer image on the map.
   */
  site.locator.ui.buildLocationHtml = function(args) {
    generic.template.get({
      path: '/templates/locator/location_info.tmpl',
      object: args.locationData,
      callback: function(html) {
        var $htm = $(html),
            $apptBookLink = $htm.find('.store-locator_book-appointment'),
            $apptBookInfo = $htm.find('.store-locator_call-to-book-appointment'),
            $apptBookLinkParent = $apptBookLink.closest('div.location-info-col2'),
            abHref = $apptBookLink.attr('href');

        if (args.locationData.APPT_BOOK_COUNTER_ID) {
          $apptBookInfo.remove();
          $apptBookLinkParent.addClass('appt-booking');
          $apptBookLink.attr('href', abHref + '?counterId=' + args.locationData.APPT_BOOK_COUNTER_ID);
          $apptBookLink.click(function(event) {
            event.preventDefault();
            window.location = $(this).attr('href');
          });
        } else {
          $apptBookLink.remove();
        }
        args.callback($htm[0]);
      }
    });
  };

  site.locator.directionsLink = function(row, doorData) {
    $('.directions_link', row).bind('click', function() {
      // window.open("https://www.google.com/maps/dir//" + doorData.LATITUDE + "," + doorData.LONGITUDE + "/", "_blank");
      // Using the store name and address rather than lat/long to get a better marker when landing on the Google site - per Alicia request MAC-975
      window.open('http://maps.google.com/maps?q=' + encodeURIComponent(doorData.DOORNAME + ',' + doorData.ADDRESS + ',' + doorData.ADDRESS2 + ',' + doorData.CITY + ',' + doorData.STATE_OR_PROVINCE + ',' + doorData.COUNTRY + ',' + doorData.ZIP_OR_POSTAL), '_blank');
      return false;
    });
  };

  site.locator.closeLink = function(row, doorData) {
    $('.location_info-close', row).bind('click', function() {
      $(window).trigger('stores::close_infobox');
    });
  };

  site.locator.showHideServices = function(show) {
    if (show) {
      site.locator.nodes.map.addClass('hidden');
      $('.store-locator.store-locator-results .store-locator-landing__form').addClass('hidden');
      site.locator.nodes.services.removeClass('hidden');
    } else {
      site.locator.nodes.map.removeClass('hidden');
      $('.store-locator.store-locator-results .store-locator-landing__form').removeClass('hidden');
      site.locator.nodes.services.addClass('hidden');
    }
  };

  site.locator.favoriteStore = function(row, doorData) {
    var storeData = doorData;
    var faveLink = $('.add-to-favorites', row);
    var faveMsg = $('.added-to-faves', row);
    var faveIcon = faveLink.find('i');
    var thisDoor = storeData.DOOR_ID;
    if (site.locator.favoriteStoreID == thisDoor || sessionStorage.DOOR_ID == thisDoor) {
      faveIcon.removeClass('icon--heart-o').addClass('icon--heart');
      faveMsg.removeClass('hidden');
    }

    faveLink.once().click(function() {
      if (faveIcon.hasClass('icon--heart-o')) {
        generic.jsonrpc.fetch({
          method: 'user.favoriteDoor',
          params: [{
            door_id: thisDoor
          }],
          onSuccess: function() {
            site.locator.favoriteStoreID = thisDoor;
            $(window).trigger('window::renderStoreDataFromFav', [[storeData]]);
            faveIcon.removeClass('icon--heart-o').addClass('icon--heart');
            faveMsg.removeClass('hidden');
          }
        });
      }
      return false;
    });
  };

  /*
   * This function builds the table of result data. It loads the JS template: /templates/locator/door_row.tmpl.
   * The site.locator.resultData.results Array must be populated.
   */
  site.locator.ui.displayResultsTable = function() {
    var tbody = null;
    var buildRow = function(doorData, idx) {
      doorData.index_number = idx;
      doorData.display_number = generic.env.domain + '/media/export/cms/store_location_pins/Stores_' + (idx + 1) + '-01.svg';
      doorData.distanceFormatted = parseFloat(doorData.DISTANCE).toFixed(2);
      doorData.distanceFormatted = isNaN(doorData.distanceFormatted) ? 'Unknown' : doorData.distanceFormatted;

      if (doorData.EVENT_START_DATE && doorData.EVENT_END_DATE) {
        var event_start = new Date(doorData.EVENT_START_DATE.replace(/-/g, ' '));
        var event_end = new Date(doorData.EVENT_END_DATE.replace(/-/g, ' '));

        // PBruno: the check for the year has to  do with JS 1.2 backwards compatibility,
        // which would in some instances spit out a four-digit full year, for all
        // years not in 1900-1999; I just check for any four digit value for year,
        // and if I find one, leave it alone (forego adding the 1900)
        doorData.EVENT_DATE = event_start.getMonth() + 1 + '/' + event_start.getDate() + '/' + (event_start.getYear() < 1000 ? parseInt(event_start.getYear()) + 1900 : event_start.getYear());
        doorData.EVENT_DATE += ' - ';
        doorData.EVENT_DATE += event_end.getMonth() + 1 + '/' + event_end.getDate() + '/' + (event_end.getYear() < 1000 ? parseInt(event_end.getYear()) + 1900 : event_end.getYear());

        var hasEvent = true;
        if (doorData.EVENT_IMAGE) {
          var image_path_parts = doorData.EVENT_IMAGE.split('.');
          image_path_parts[0] += '_lrg';
          doorData.EVENT_LARGE_IMAGE = image_path_parts.join('.');
        }
      }

      if (typeof doorData.STORE_HOURS === 'object') {
        doorData.parsed_hours = '';
        for (var s = 0; s < doorData.STORE_HOURS.length; s++) {
          var hours = doorData.STORE_HOURS[s].hours || '';
          hours = hours.trim();
          hours = hours.replace(/ /g, '&nbsp;');
          doorData.parsed_hours += '<tr><td>' + doorData.STORE_HOURS[s].day + '</td><td>' + hours + '</td></tr>';
        }
      }

      generic.template.get({
        path: '/templates/locator/door_row.tmpl',
        object: doorData,
        callback: function(html) {
          var idx = doorData.index_number;
          var node = $(html);

          // Appointment Booking
          var $apptBookLink = node.find('.store-locator_book-appointment'),
              $apptBookInfo = node.find('.store-locator_call-to-book-appointment'),
              $apptBookLinkParent = $apptBookLink.closest('div.door_info'),
              abHref = $apptBookLink.attr('href');

          if (doorData.APPT_BOOK_COUNTER_ID) {
            $apptBookInfo.remove();
            $apptBookLinkParent.addClass('appt-booking');
            $apptBookLink.attr('href', abHref + '?counterId=' + doorData.APPT_BOOK_COUNTER_ID);
            $apptBookLink.click(function() {
              event.preventDefault();
              window.location = $(this).attr('href');
            });
          } else {
            $apptBookLink.remove();
          }

          tbody.append(node);
          var row = tbody.find('tr.door_row_' + idx);
          site.locator.nodes.doorRows.add(row);
          // store hours
          if (typeof doorData.parsed_hours !== 'undefined') {
            row.find('.hours_link').removeClass('hidden');
            row.find('.hours_link').bind('click', function(e) {
              e.preventDefault();
              var hours_div = tbody.find('tr.js-door_hours_' + idx);
              if (hours_div.hasClass('hidden')) {
                hours_div.removeClass('hidden');
                if (parseInt($.cookie('client.isMobile')) === 1) {
                  $('html, body').animate({
                    scrollTop: Math.min($(window).scrollTop() + hours_div.height(), row.offset().top - 60)
                  }, 300);
                }
              } else {
                hours_div.addClass('hidden');
              }
              site.locator.ui.initScrollButtons();
            });
          }

          var isMakeupServiceStore = doorData.STORE_TYPE === 'Service Store';

          if (isMakeupServiceStore) {
            var makeup_service_store_link = tbody.find('tr.door_row_' + idx + ' .makeup_store_link');
            var makeup_services_link = tbody.find('tr.door_row_' + idx + ' .services_link');
            if (!Drupal.settings.globals_variables.hide_makeup_service_store) {
              makeup_service_store_link.removeClass('hidden');
            }
            makeup_services_link.hide();
          }
          var isMakeupDoorIDVar = $('.makeup_door_link').attr('data-doorId_var');
          if (doorData.DOOR_ID === parseInt(isMakeupDoorIDVar)) {
            var makeupServiceDoorIDLink = tbody.find('tr.door_row_' + idx + ' .makeup_door_link');
            makeupServiceDoorIDLink.removeClass('hidden');
          }
          // make-up services
          row.find('.services_link.desktop').bind('click', function(e) {
            e.preventDefault();
            site.locator.showHideServices(true);
            site.locator.ui.initScrollButtons();
          });

          // NEW flag
          if (doorData.COMMENTS !== null && doorData.COMMENTS.toString().trim().toUpperCase() === 'NEW') {
            row.find('.js-new').removeClass('hidden');
          }

          // events
          if (doorData.EVENT_START_DATE !== null && doorData.EVENT_END_DATE !== null && doorData.EVENT_NAME !== '') {
            var event_start = new Date(doorData.EVENT_START_DATE.replace(/-/g, ' '));
            var event_end = new Date(doorData.EVENT_END_DATE.replace(/-/g, ' '));
            // show only if the end date hasn't passed yet
            if (event_end > new Date()) {
              var dayNames = $('[data-local_days_of_week]').attr('data-local_days_of_week');
              dayNames = !_.isEmpty(dayNames) ? dayNames.replace(/"/g, '').split(',') : '';

              var dayOfWeek = _.startsWith(doorData.EVENT_START_DATE, dayNames[event_start.getDay()]) ? '' : dayNames[event_start.getDay()] + ' ';
              doorData.EVENT_START_DATE = dayOfWeek + event_start.toLocaleDateString(); //doorData.EVENT_START_DATE.replace(/00:00:00/g, '');
              doorData.EVENT_END_DATE = event_end.toLocaleDateString(); //doorData.EVENT_END_DATE.replace(/00:00:00/g, '');
              row.find('.events_link').removeClass('hidden');
              row.find('.events_link').bind('click', function(e) {
                e.preventDefault();
                var events_div = tbody.find('tr.js-door_events_' + idx);
                if (events_div.hasClass('hidden')) {
                  events_div.removeClass('hidden');
                  if (parseInt($.cookie('client.isMobile')) === 1) {
                    $('html, body').animate({
                      scrollTop: Math.min($(window).scrollTop() + events_div.height(), row.offset().top - 60)
                    }, 300);
                  }
                } else {
                  events_div.addClass('hidden');
                }
                site.locator.ui.initScrollButtons();
              });
            }
          }

          /*
          if (hasEvent) {
            site.locator.nodes.doorWithEventRows.add(row);

            row.find(".event-details a.view-details").bind("click", function(e) {
              e.preventDefault();
              generic.template.get({
                path:'/templates/locator/doors_event_popup.tmpl',
                object: doorData,
                callback: function (html) {
                  var content = $(html);
                  content.filter(".event-large-image").error(function() {
                    $(this).css("display", "none");
                  });
                  generic.overlay.launch({
                    content: content,
                    includeBackground: true,
                    includeCloseLink: true,
                    cssClass: "store-locator-popup-v1",
                    cssStyle: {
                       width: '700px',
                       padding: '25px'
                    }
                  });
                }
              });
            });
          }
          */
          row.bind('click', function() {
            site.locator.ui.launchInfoWindow(idx);
          });

          site.locator.directionsLink(row, doorData);

          // add filterable attributes
          var store_types = 'all';
          if (doorData.STORE_TYPE === 'MAC Pro') {
            store_types += '|pro';
          }
          if ((doorData.STORE_TYPE === 'MAC Pro') || (doorData.STORE_TYPE === 'Pro Discount')) {
            store_types += '|disc';
          }
          if (doorData.STORE_TYPE === 'MAC') {
            store_types += '|mac';
          }
          if ((doorData.STORE_TYPE === null) || (doorData.STORE_TYPE === '')) {
            store_types += '|dept';
          }
          if (doorData.STORE_TYPE === 'Travel Retail') {
            store_types += '|air';
          }
          $(row).attr('data-store_types', store_types);
        }
      });
    };

    generic.template.get({
      path: '/templates/locator/doors_table.tmpl',
      callback: function(html) {
        site.locator.nodes.storeResults.html(html);
        tbody = site.locator.nodes.storeResults.find('tbody');
        var searchQuery;
        var totalResults;

        if (site.locator.queryArgs.params !== undefined && site.locator.queryArgs.params.length) {
          var params = site.locator.queryArgs.params[0],
              searchCriteria = [],
              paramKeys = ['state', 'city'];

          if (site.locator.addressDisplayData) {
            searchCriteria.push(site.locator.addressDisplayData);
            site.locator.addressDisplayData = null;
          } else if (params.zip !== '' && params.zip !== undefined) {
            searchCriteria.push(params.zip);
          } else if (site.locator.queryArgs.addressDisplayData) {
            searchCriteria.push(site.locator.queryArgs.addressDisplayData);
          } else {
            for (var i = 0; i < paramKeys.length; i++) {
              var paramKey = paramKeys[i];
              if (params[paramKey] !== undefined) {
                searchCriteria.push(params[paramKey]);
              }
            }
          }
          searchQuery = $.trim(searchCriteria.join(' '));

          totalResults = site.locator.resultData.sortedResults.length;
          site.locator.nodes.storeResults.each(function() {
            site.locator.storeResultsText(this, totalResults, searchQuery);
          });
        }
        var index = 0;
        for (var d in site.locator.resultData.sortedResults) {
          if (d !== '') {
            buildRow(site.locator.resultData.sortedResults[d], index);
            index++;
          }
        }

        // init custom scroll buttons
        site.locator.ui.initScrollButtons();

        // set filters
        site.locator.ui.setFilters();

        omnidata = [searchQuery, totalResults];
        tms_page_data.tms_page_info.STORELOCATOR = omnidata;
        jQuery(window).trigger('STORELOCATOR', [omnidata]);
      }
    });

    var _clearMenu = function(menu) {
      menu.select2('val', '');
      menu[0].innerHTML = '';
      generic.forms.select.addOption({
        menuNode: menu,
        label: menu.attr('title') ? menu.attr('title') : site.locator.nodes.select_text.text(),
        value: ''
      });
    };

    // hide landing node ref content
    site.locator.nodes.landing_only_panel.hide();
  };

  site.locator.storeResultsText = function(currentObj, resultsCount, searchQuery) {
    var resultElement = '';
    $('.js-results-count', currentObj).hide();
    if (resultsCount === 1) {
      resultElement = $('.js-results-count-singular', currentObj);
    } else if (resultsCount >= 5 && $('.js-more-than-five-plural', currentObj).length > 0) {
      resultElement = $('.js-more-than-five-plural', currentObj);
    } else {
      resultElement = $('.js-results-count-plural', currentObj);
    }
    resultElement.html(resultElement.html().replace('::count::', '<span class="count">' + resultsCount + '</span>').replace('::query::', '<span class="query">' + searchQuery + '</span>')).show();
    //To update the filter the output count value
    resultElement.find('.count').html(resultsCount);
  };

  /*
   * This function encapsulates the various calls to the Google Maps API that render
   * the map of results. It initializes a google.maps.Map object (storing it in site.locator.map),
   * adds markers, and sets up the event handler for clicking on the markers.
   * The site.locator.resultData.results Array must be populated.
   */
  site.locator.ui.displayMap = function(i) {
    var results = i === 0 || i ? [i] : site.locator.resultData.results;
    var mapNode = site.locator.nodes.map;
    var mapOptions,
        map;

    // if there are no results, center the map on the US, display the map, and just return
    if (!results || results.length === 0) {
      mapOptions = {
        zoom: 4,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: false,
        navigationControl: true,
        mapTypeControl: false,
        scaleControl: true
      };
      map = new google.maps.Map(mapNode[0], mapOptions);
      var geocoder = new google.maps.Geocoder();

      geocoder.geocode({'address': 'US'}, function(results, status) {
        var ne = results[0].geometry.viewport.getNorthEast();
        var sw = results[0].geometry.viewport.getSouthWest();

        map.fitBounds(results[0].geometry.viewport);
      });
      mapNode.show();
      return;
    } else {
      // if we're here, there is result data, proceed accordingly
      var zoomLevel = 12;
      mapOptions = {
        zoom: zoomLevel,
        center: new google.maps.LatLng(site.locator.resultData.latitude, site.locator.resultData.longitude),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: false,
        navigationControl: true,
        mapTypeControl: false,
        scaleControl: false
      };
      map = new google.maps.Map(mapNode[0], mapOptions);

      site.locator.map = map;

      //site.locator.nodes.landingPanel.hide();
      mapNode.show();

      var location,
          lat,
          lng,
          latLng,
          marker;

      var idx = 0;
      var _buildLocationHtml = function(location) {
        site.locator.ui.buildLocationHtml({
          locationData: location,
          callback: function(html) {
            // NEW flag
            if (location.COMMENTS !== null && location.COMMENTS.toString().trim().toUpperCase() === 'NEW') {
              html = $(html).find('.js-new').removeClass('hidden').end()[0].outerHTML;
            }
            site.locator.locationsHtml[location.idx] = html;
            // display info window on first location
            if (location.idx === 0) {
              site.locator.ui.launchInfoWindow(location.idx);
            }
          }
        });
      };

      for (var result in results) {
        if (result !== '') {
          // place markers on Google Map
          location = site.locator.resultData.sortedResults[idx];
          lat = location.LATITUDE;
          lng = location.LONGITUDE;
          latLng = new google.maps.LatLng(lat, lng);

          // original icon size was 23x41
          marker = new google.maps.Marker({
            position: latLng,
            map: map,
            icon: {
              url: generic.env.domain + '/media/export/cms/store_location_pins/Stores_' + (idx + 1) + '-01.svg',
              scaledSize: new google.maps.Size(31, 41),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(0, 41)
            },
            optimized: false,
            index: idx,
            title: location.DOORNAME
          });

          //var zIndex = 20 - idx;
          //marker.setZIndex(zIndex);

          site.locator.markers[idx] = marker;

          location.idx = idx;
          _buildLocationHtml(location);
          /* jshint ignore:start */
          eval("google.maps.event.addListener( marker, 'click', function(e) { site.locator.ui.launchInfoWindow( " + idx + ');});');
          /* jshint ignore:end */

          // launch info window on click of marker (on map)
          //google.maps.event.addListener( marker, 'click', function(e) {
          //    site.locator.ui.launchInfoWindow(idx);
          //});
          //
          // set map center for first location
          if (idx === 0) {
            map.setCenter(latLng);
          }
          ++idx;
        }
      }
    }
  };

  /*
   * Displays Info Window for a given marker/door.
   * @param i {Number} index of door/marker for which info window should be displayed
   * @param directions {bool} if true indicates we're launching on the directions map rather than the main one
   */
  site.locator.ui.launchInfoWindow = function(i) {
    var location = site.locator.resultData.sortedResults[i];
    var map = site.locator.map;

    /*
     * custom info windows using Google's InfoBox library:
     * http://google-maps-utility-library-v3.googlecode.com/svn/tags/infobox/1.1.9/docs/reference.html
     */
    var infoBoxOptions = {
      alignBottom: true,
      disableAutoPan: false,
      maxWidth: 0,
      pixelOffset: new google.maps.Size(-270, -60),
      zIndex: null,
      boxStyle: {
        maxWidth: '540px',
        minWidth: '300px'
      },
      closeBoxURL: '',
      infoBoxClearance: new google.maps.Size(1, 1),
      isHidden: false,
      pane: 'floatPane',
      enableEventPropagation: false
    };

    if (site.locator.infoWindow) {
      site.locator.infoWindow.close();
    }

    site.locator.infoWindow = new InfoBox(infoBoxOptions);

    var infoWindow = site.locator.infoWindow;
    var infoWindowContent = $('<div></div>');
    infoWindowContent.html(site.locator.locationsHtml[i]);
    site.locator.closeLink(infoWindowContent, location);
    site.locator.directionsLink(infoWindowContent, location);
    site.locator.favoriteStore(infoWindowContent, location);

    infoWindow.setContent(infoWindowContent[0]);

    var marker = site.locator.markers[i];
    infoWindow.open(map, marker);

    $(window).on('stores::close_infobox', function() {
      infoWindow.close();
    });

    map.setCenter(marker.position);
    map.panBy(0, -100);

    site.locator.markerCounter++;
  };

  $(document).ready(function() {
    $(window).on('gnavdata_success', function(e, results) {
      site.locator.favoriteStoreID = results.DOOR_ID;
    });

    site.locator.getDomNodes();
    //site.locator.ui.getRBs();
    site.locator.ui.init();
    site.locator.ui.getTemplates();
    site.locator.ui.jsDropdownToggle();
    //site.locator.ui.saveToCalendar();
  }); // end dom:loaded

  /*
   * This function handles the query submit event. It parses the data from the event memo
   * and passes it to the fetch method. This method should NOT be called directly by a UI method;
   * rather, the params should be passed as part of the memo to the locator:submitSearchQuery event.
   * @param {function} args.callback a function that gets called after door data is returned
   * @param {Array} args.params an Array that contains a hash of parameters that get
   * passed to the JSON-RPC method.
   * @param {Array} args.params[0].fields The data fields to be returned from the JSON-RPC request
   * @param {number} args.params[0].radius The distance from the origin point inside which stores should be returned.
   * @param {string} args.params[0].zip Postal Code of origin point location
   * @param {string} args.params[0].state State of origin point location
   * @param {string} args.params[0].city City of origin point location
   * @param {Array} args.params[0].show_stores_list Array of Store Names by which results should be filtered. Empty array
   * should be passed to return all stores.
   * @example
   * // var queryArgs = {
   * //     params : [{
   * //         fields : "DOOR_ID, DOORNAME, STORE_HOURS, ADDRESS, ADDRESS2, STATE_OR_PROVINCE, CITY",
   * //         radius : 25,
   * //         zip    : "10014",
   * //         state  : "NY",
   * //         city   : "New York"
   * //     }],
   * //     callback : function() {
   * //          site.locator.ui.displayMap();
   * //          site.locator.ui.displayResultsTable();
   * //      }
   * // };
   */
  site.locator.data.submitQuery = function(args) {
    var params = args.params;
    var callbackFn = args.callback;
    var zipRegEx = new RegExp(/(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnpstvxy]{1}\d{1}[A-Za-z]{1} ?\d{1}[A-Za-z]{1}\d{1})$/);

    if (!params[0].use_header && (!params[0].latitude && !params[0].longitude)) {
      _showErrorMsg(site.locator.nodes.errors.noLocationsFound);
      return;
    }

    site.locator.data.fetch({
      data: params,
      onSuccess: function(resultData, countersData) {
        var i;
        var count = countersData?.length || '';
        var cData = {};
        var res = {};
        _hideErrorMsg();
        // if no results were found...
        if (resultData.count === 0) {
          _showErrorMsg(site.locator.nodes.errors.noStoresFound);
        } else {
          site.locator.nodes.results_panel.slideDown('300', function() {
            if (parseInt($.cookie('client.isMobile')) === 1) {
              $('html, body').animate({
                scrollTop: site.locator.nodes.results_panel.offset().top - 60
              }, 300);
            }
            site.locator.nodes.wrapper.removeClass('store-locator-landing').addClass('store-locator-results');
            site.locator.ui.displayResultsTable();
            site.locator.ui.displayMap();
          });
          if (site.locator.nodes.formSearchAdvanced.hasClass('has-js-dropdown-open')) {
            site.locator.nodes.jsDropdownToggle.trigger('click');
          }
        }
        resultData.maxDistance = parseFloat(args.params[0].radius);
        if (isNaN(resultData.maxDistance)) {
          resultData.maxDistance = null;
        }

        if (Drupal.settings.globals_variables.appt_store_locator) {
          for (i = 0; i < count; i++) {
            cData = countersData[i];
            res = resultData.results[cData.store_no];

            if (res) {
              res.APPT_BOOK_COUNTER_ID = cData.id;
            }
          }
        }

        site.locator.data.setData(resultData);
        if (typeof callbackFn === 'function') {
          callbackFn();
        }
      },
      onFailure: function(jsonRpcResponse) {
        var errorObjectsArray = jsonRpcResponse.getMessages();
        _showErrorMsg(site.locator.nodes.errors.noStoresFound);
      }
    });
  };

  $(document).bind('locator.submitSearchQuery', function(evt, param) {
    site.locator.data.submitQuery(param);
  });

  /*
   * Callback function that handles response from JSON-RPC request. It filters
   * and sorts the result data, then places the data in the global variable
   * site.locator.resultData.results
   */

  site.locator.data.fetch = function(args) {
    var params = args.data;
    generic.jsonrpc.fetch({
      method: 'locator.doorsandevents',
      params: params,
      onSuccess: function(r) {
        var resultData = r.getValue();
        if (Drupal.settings.globals_variables.appt_store_locator) {
          generic.jsonrpc.fetch({
            method: 'appointmentbooking.getauthtoken',
            onSuccess: function(rpc) {
              var token = rpc.getValue().auth_token;
              $.ajax(
                {
                  url: 'https://' + window.location.hostname + '/_abapi/api/v1/counters',
                  type: 'GET',
                  data: {token: token},
                  success: function(counters) {
                    args.onSuccess(resultData, counters);
                  },
                  error: function(err) {
                    args.onSuccess(resultData, []);
                  }
                }
              );
            },
            onError: function(rpc) {
              //console.log("Error getting authorization token");
            }
          });
        } else {
          args.onSuccess(resultData);
        }
      },
      onFailure: function(r) {
        args.onFailure(r);
      }
    });
  };

  /*
   * Callback function that handles response from JSON-RPC request. It filters
   * and sorts the result data, then places the data in the global variable
   * site.locator.resultData.results
   */
  site.locator.data.setData = function(rawResultData) {
    site.locator.resultData = rawResultData;
    if (rawResultData.maxDistance) { // max distance exists
      var filteredResults = {};
      for (var d in rawResultData.results) {
        if (d !== '') {
          if (rawResultData.results[d].DISTANCE < rawResultData.maxDistance) {
            filteredResults[d] = rawResultData.results[d];
          }
        }
      }
      site.locator.resultData.results = filteredResults;
    }

    // asc. sort by distance
    var sortedResults = [];
    var r = site.locator.resultData.results;
    var sortedDoorIds = site.locator.resultData.doors || [];

    function sortByDistance(a, b) {
      var aDist = !r[a].DISTANCE || isNaN(r[a].DISTANCE) ? 0 : parseFloat(r[a].DISTANCE);
      var bDist = !r[b].DISTANCE || isNaN(r[b].DISTANCE) ? 0 : parseFloat(r[b].DISTANCE);
      if (aDist > bDist) {
        return 1;
      } else if (aDist < bDist) {
        return -1;
      }
      return 0;
    }

    sortedDoorIds.sort(sortByDistance);

    for (var i = 0; i < sortedDoorIds.length; i++) {
      sortedResults.push(site.locator.resultData.results[sortedDoorIds[i]]);
    }
    site.locator.resultData.sortedResults = sortedResults;
  };

  var doorDetails = function(index) {
    $('.directions_link').eq(index).click();
  };

  site.locator.ui.jsDropdownToggle = function() {
    site.locator.nodes.jsDropdownToggle.bind('click', function() {
      if (parseInt($.cookie('client.isMobile')) === 1) {
        if (site.locator.nodes.formSearchAdvanced.hasClass('has-js-dropdown-open')) {
          site.locator.nodes.formSearchAdvanced.toggleClass('has-js-dropdown-open').find('.options').slideUp('300');
        } else {
          site.locator.nodes.formSearchAdvanced.toggleClass('has-js-dropdown-open').find('.options').slideDown('300', function() {
            $('html, body').animate({
              scrollTop: site.locator.nodes.formSearchAdvanced.find('.options').offset().top - $('#site-header').height()
            }, 500);
          });
        }
      } else {
        site.locator.nodes.formSearchAdvanced.toggleClass('has-js-dropdown-open').find('.options').slideToggle();
      }
    });
  };

  site.locator.ui.filterResults = function($filter_option) {
    var filter_by = $filter_option;
    var $new_list = $('tr.door_row[data-store_types]');
    $('tr.door_hours').addClass('hidden');
    $('tr.door_events').addClass('hidden');
    $new_list.addClass('hidden');
    $new_list = $new_list.filter('[data-store_types*="' + filter_by + '"]');
    $new_list.removeClass('hidden');

    var filter_count = $new_list.length;
    site.locator.nodes.storeResults.each(function() {
      site.locator.storeResultsText(this, filter_count);
    });

    site.locator.ui.initScrollButtons();
  };

  site.locator.ui.initScrollButtons = function() {
    // Can be set on first load
    var $resultsMask = $('.doors_results-wrapper', site.locator.nodes.results_panel);
    var resultsHeight = $('.doors_results', $resultsMask).height(); // total height of all results
    var maskHeight = $resultsMask.height(); // this is set once full height
    var scrollAmount = Math.floor(maskHeight / 3);

    // Don't do our prev/next checks until after we're done scrolling
    var debouncedScrollTopCheck = _.debounce(function() {
      var scrollTop = $(this).scrollTop();

      resultsHeight = $('.doors_results', $resultsMask).height();

      site.locator.nodes.results_panel.removeClass('shade-picker--no-next-controls shade-picker--no-prev-controls');

      if (scrollTop === 0) {
        site.locator.nodes.results_panel.addClass('shade-picker--no-prev-controls');
      }
      if (scrollTop === (resultsHeight - maskHeight) || (resultsHeight - maskHeight) <= 0) {
        site.locator.nodes.results_panel.addClass('shade-picker--no-next-controls');
      }
    }, 250);

    $resultsMask.on('scroll', debouncedScrollTopCheck).scroll();

    $('.shade-picker__next', site.locator.nodes.results_panel).once().click(function() {
      $resultsMask.scrollTo('+=' + scrollAmount + 'px', 500);
    });
    $('.shade-picker__previous', site.locator.nodes.results_panel).once().click(function() {
      $resultsMask.scrollTo('-=' + scrollAmount + 'px', 500);
    });

    // check the total shades height, if shallower than the mask hide controls
    //if ($product.hasClass('product--full')) {
    //  var fullShadesHeight = $('.shade-picker__colors', $product).height(),
    //    fullMaskHeight = $('.shade-picker__colors-mask', $product).height(),
    //    $mask = $('.shade-picker__colors-mask', $product),
    //    $controls = $('.shade-picker__controls-wrapper', $product);
    //  if (fullShadesHeight <= fullMaskHeight) {
    //    $mask.css('top', 0);
    //    $controls.hide();
    //  }
    //}
  };

  site.locator.ui.setFilters = function() {
    $('.description', site.locator.nodes.results_panel).find('p').hide();
    $('select.filters', site.locator.nodes.results_panel).unbind().select2('val', 'all').on('change', function(e) {
      var filter_val = $(this).val();
      site.locator.ui.filterResults(filter_val);
      $('.description', site.locator.nodes.results_panel).find('p').hide();
      $('.description', site.locator.nodes.results_panel).find('p.' + filter_val).show();
    });
    $('select.filters option', site.locator.nodes.results_panel).remove();
    site.locator.nodes.filterMenu.append(site.locator.nodes.filtersOptions);
    $('select.filters option', site.locator.nodes.results_panel).each(function() {
      var filter_val = $(this).val();
      if ($('tr.door_row[data-store_types*="' + filter_val + '"]').size() === 0 && filter_val != 'all') { // this filter has no results
        $(this).remove();
      }
    });
  };

  site.locator.chooseRandomBGImage = function() {
    var $wrapper = $('.store-locator.store-locator-landing');
    var imgs = $wrapper.attr('data-bg_images').split(',');
    var img_values = imgs.filter(function(val) {
      return val !== '';
    });
    var img = img_values[Math.floor(Math.random() * img_values.length)];
    $wrapper.css('background-image', "url('" + img + "')");
  };

  var _showErrorMsg = function(errorMsg) {
    errorMsg.removeClass('hidden');
  };

  var _hideErrorMsg = function() {
    $.each(site.locator.nodes.errors, function() {
      $(this).addClass('hidden');
    });
  };

  var _disableSearchBtn = function() {
    if (site.locator.nodes.countryMenu.val() !== '' && site.locator.nodes.cityMenuIntl.val() !== '') {
      site.locator.nodes.searchBtnIntl.removeAttr('disabled');
    } else {
      site.locator.nodes.searchBtnIntl.attr('disabled', 'disabled');
    }
  };
})(jQuery, Drupal, site || {});
